var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLogout = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-navi-logout",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.000000, 6.000000)",
    stroke: "#0084F8",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Disclosure-Indicator",
    points: "10 0 15 5.5 10 11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.5,
    y1: 5.5,
    x2: 0.5,
    y2: 5.5,
    id: "Line",
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#0084F8",
    strokeWidth: 2,
    transform: "translate(5.500000, 11.000000) scale(-1, 1) translate(-5.500000, -11.000000) ",
    x: 0,
    y: 0,
    width: 11,
    height: 22
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logout.f86cd431.svg";
export { ForwardRef as ReactComponent };